import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ModalDelete from './ComponentModalDelete';
import ModalImage from './ComponentModalImage';
import T from '../../Locale';
import { currencyFormat } from '../../../components/Tools';
import ListItem from './ComponentListItem';
import ComponentListCategories from './ComponentListCategories';
import { getType } from './ValueTypes';
import ComponentListItemNew from './ComponentListItemNew';
import ModalCreate from './ComponentModalCreate';
class ComponentList extends Component {
    constructor(props) {
        super(props);
        this.state = { categorySelected: 'all' };
        this.getAvailableCategories = this.getAvailableCategories.bind(this);
        this.getItems = this.getItems.bind(this);
    }
    getAvailableCategories() {
        const { items } = this.props;
        const categories = {};
        items.forEach((item) => {
            categories[item.type] = getType(item.type);
        });
        return Object.values(categories);
    }
    getItems() {
        const { categorySelected } = this.state;
        const { items } = this.props;
        if (categorySelected !== 'all') {
            return items.filter((item) => item.type === categorySelected);
        }
        return items;
    }
    render() {
        const { categorySelected } = this.state;
        const { items } = this.props;
        let totalValue = 0;
        // Calculate the total value by looping all items.
        items.forEach((item) => {
            totalValue += parseInt(item.value, 10);
        });
        return (_jsxs("div", Object.assign({ className: "values-list" }, { children: [_jsx(ModalDelete, {}), _jsx(ModalImage, {}), _jsx("div", Object.assign({ className: "row" }, { children: _jsx("div", Object.assign({ className: "columns" }, { children: _jsx(ComponentListCategories, { categories: this.getAvailableCategories(), selected: categorySelected, onSelect: (category) => this.setState({ categorySelected: category }) }) })) })), _jsxs("div", Object.assign({ className: "row" }, { children: [_jsxs("div", Object.assign({ className: "small-10 small-offset-1 medium-6 medium-offset-0 large-3 columns" }, { children: [_jsx(ModalCreate, {}), _jsx(ComponentListItemNew, {})] })), this.getItems().map((item) => (_jsx("div", Object.assign({ className: "small-10 small-offset-1 medium-6 medium-offset-0 large-3 columns" }, { children: _jsx(ListItem, { item: item }) }), item.id)))] })), _jsxs("div", Object.assign({ className: "row values-list__total" }, { children: [_jsx("div", Object.assign({ className: "columns small-12 medium-6" }, { children: _jsx("h3", { children: T.translate('values.total') }) })), _jsx("div", Object.assign({ className: "columns small-12 medium-6 text-right" }, { children: _jsxs("h3", { children: [T.translate('misc.currency'), currencyFormat(totalValue), ",-"] }) }))] }))] })));
    }
}
ComponentList.propTypes = { items: PropTypes.array };
ComponentList.defaultProps = { items: [] };
const mapStateToProps = (state) => ({ items: state.values.items });
export default connect(mapStateToProps)(ComponentList);
